import { Component, OnInit, NgZone, ChangeDetectorRef,Output,Input,EventEmitter, ElementRef, ViewChild } from '@angular/core';
import { AccountService, InstoreService } from '@app/_services';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Renderer2 } from '@angular/core';
import { Router} from "@angular/router"
import { first } from 'rxjs/operators';
import { ToastrService,IndividualConfig } from 'ngx-toastr';
import { NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
import { MapsAPILoader, MouseEvent as AGMMouseEvent, AgmMap } from '@agm/core'  
import * as moment from 'moment'; 
import { ConfirmDialogService } from '@app/module/confirm-dialog/confirm-dialog/confirm-dialog.service';  
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { DataService } from '@app/_services';

@Component({
  selector: 'app-hoardinglist',
  templateUrl: './hoardinglist.component.html',
  styleUrls: ['./hoardinglist.component.css']
})
export class HoardinglistComponent implements OnInit {
  @ViewChild('agmMap') agmMap : AgmMap
  private format = 'YYYY-MM-DD';
  @Output() messageEvent = new EventEmitter<string>();
  @Input() startDateLabel: string;
  @Input() endDateLabel: string;
  @Input() startDateInput;
  @Input() endDateInput;
  @Output() StartEndDatesOutput = new EventEmitter();
  AssetsDataLists;
  CreativeDataLists;
  RegionDataLists;
  ShowroomDataLists;
  f_Region_Showroom_list;
  isLoading = false;
  isLog = false;
  isShowTab = true;
  all_HoardingsLists;
  VendorDataLists;
  filtered_HoardingsLists;
  FloorDataLists;


  filtered_detail_HoardingsLists;
  
  form: UntypedFormGroup;
  submitted = false;
  isEdit:boolean=false;
  page = 1;
  pageSize = 10;
  d_selected_hoardingName:string;
  d_selected_hoardingID:number;
  selected_region_id :number;
  selected_region_name :string;
  selected_showroom_id :number;
  selected_showroom_name :string;
  nSubModule = 1;
  isAllHoardingsChecked:boolean;
  selectedHoarding_Lists:any;
  options: IndividualConfig;
  hoardingCurrentData;
  hoardingPreviousData;
  term: string;
  filterform: UntypedFormGroup;
  minDate: any;
  todayDate:Date = new Date();
  d_hoardingData:any =[];
  imageSrc;

  zoom:number;
  address: string;

  HoardingExpiredLists:any;
  FilteredHoardingExpiredLists:any;

  nExpired0:any;
  nExpiredAll:any;
  nExpiredNot:any;

  nUnchange10:any;
  nUnchange30:any;
  nUnchange180:any;
  nUnchange720:any;
  nUnchange1825:any;
  isFromDashboard:boolean = false;

  selectedAssetID = [];
  selectedCreativeIds =[];
  selectedVendorIds =[];

  dropdownList = [];

  dropdownSettings:IDropdownSettings;
  
  user_role_id: number=0;
  user_region_id: number=0;
  user_showroom_id: number=0;
  is_Admin_User:boolean = true;
  is_Admin_can_Edit:boolean = true;

  constructor(private formBuilder: UntypedFormBuilder,
    private cdRef: ChangeDetectorRef,private dataService:DataService,
    private accountService: AccountService,private modalService: NgbModal, 
    private router: Router, private instoreService: InstoreService,private toastr: ToastrService,fb: UntypedFormBuilder,
    private mapsAPILoader: MapsAPILoader,private confirmDialogService: ConfirmDialogService ,
    private ngZone: NgZone,
    private renderer: Renderer2) {
        this.isAllHoardingsChecked = false;
        this.options = this.toastr.toastrConfig;
        this.options.timeOut = 1000;
     }
  ngOnInit(): void {

    var userdata = localStorage.getItem('userInformation');
    var _data = JSON.parse(userdata);
    if(_data) {
      this.user_role_id = _data.role_id;
      this.user_region_id = _data.region_id;
      this.user_showroom_id = _data.showroom_id;

      if(this.user_role_id==1 || this.user_role_id == 2){
        this.is_Admin_User = true
      }else{
        this.is_Admin_User = false
      }

      if(this.is_Admin_User){
        if(_data.is_view == 1){
          this.is_Admin_can_Edit = false;
        }else{
         this.is_Admin_can_Edit = true;
        }
      }
    }

    
    this.isFromDashboard = false;
    this.filterform = this.formBuilder.group({
      asset_type_id: [''],
      creative_id: [''], 
      vendor_id: [''], 
      search: ['']
    });
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'name',
      selectAllText: 'Select All',
      unSelectAllText: 'Unselect All',
      itemsShowLimit: 2,
   }
    this.form = this.formBuilder.group({
      hoarding_id:'',
      address: [''],
      area: [''],
      particulars: [''], 
      region_id: [''], 
      showroom_id: [''], 
      floor_id: [''], 
      asset_type_id: [''], 
      creative_id: [''], 
      vendor_id: [''], 
      name : [''], 
      size_w: [''], 
      size_h: [''], 
      square_feet:[''],
      install_date: [''], 
      expiry_date: [''], 
      image: [''],
      cost:['']    });

      this.form.controls['install_date'].setValue(this.startDateInput);
      if (this.form.controls['install_date'].value) {
        if (this.endDateInput) {
          this.form.controls['expiry_date'].setValue(this.endDateInput);
          this.endDateClicked();
        }
      }


      this.d_hoardingData= this.instoreService.getHoardingData();
      
      if(Object.keys(this.d_hoardingData).length != 0){
        this.isFromDashboard = true;
         this.nSubModule=3;
         this.d_selected_hoardingID = this.d_hoardingData.id;
         this.d_selected_hoardingName = this.d_hoardingData.name;
         this.showHoardingData(this.d_hoardingData.region_id, this.d_hoardingData.regionName, this.d_hoardingData.showroom_id, this.d_hoardingData.showroomName);
         this.instoreService.clearHoardingData();
      }else{
          this.isFromDashboard = false;
          this.nSubModule=1;
      }

      this.reloadAssetsLists();
      this.reloadCreativeLists();
      this.reloadRegionLists();
      this.reloadShowroomLists();
      // this.loadHoardingsData();
      this.reloadFloorLists();
      this.reloadVendorLists();
      this.getExpiredData();

  }
  getExpiredData() {
    this.instoreService.getHoardingExpiryAdds(this.user_region_id,this.user_showroom_id)
    .pipe(first())
      .subscribe(
      (response) => {
        this.nExpired0 = response.result.expiry_0;
        this.nExpiredNot = response.result.expiry_10;
        this.nExpiredAll = response.result.expiry_1;
        this.isLoading = false;
        this.loadExpiredData(1)
      },
      (error) => {     
        this.isLoading = false;   
        console.log("getExpiredData Error");                            
      }
    );
  } 
  public splitNumber(value: number):string {
    if(value!=null){
      if(value == 0){
        return 0+"";
      }
      return Math.round(value * 100) / 100+"'";
    }
  }
  loadExpiredData(expiryDays){
    this.page = 1;
    this.HoardingExpiredLists =[];
    if(expiryDays === 0){
        this.HoardingExpiredLists = this.nExpired0;
    }else  if(expiryDays === 10){
        this.HoardingExpiredLists = this.nExpiredNot;
    }else{
        this.HoardingExpiredLists = this.nExpiredAll;
    }
    this.FilteredHoardingExpiredLists = this.HoardingExpiredLists;
    this.sortArray(this.FilteredHoardingExpiredLists)
    this.loadUnchangedAdsData()
    
  }
  loadUnchangedAdsData() {
    this.instoreService.getHoardingUnchangedAds(this.user_region_id, this.user_showroom_id).pipe(first())
      .subscribe(
      (response) => {
        this.isLoading = false;
        this.nUnchange10 = ""+response.result.unchanged_10.length;
        this.nUnchange30 = ""+response.result.unchanged_30.length;
        this.nUnchange180 = ""+response.result.unchanged_180.length;
        this.nUnchange720 = ""+response.result.unchanged_720.length;
        this.nUnchange1825 = ""+response.result.unchanged_1825.length;
        //console.log("getExpiredData"+response.result.expiry10.length);
      },
      (error) => {     
        this.isLoading = false;                               
      }
    );  
  }

  omit_special_char(event) {   
    var k;  
    k = event.charCode;  //         k = event.keyCode;  (Both can be used)
    return((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57)); 
  }

  selectedHoarding_ID :number;
  imageHoarding :String;
  nameHoarding:string;

  getExipreName(days) {
    if(days < 0 ) {
      return "Expired";
    } else {
      return "Not Expired";
    }
  }
  getColor(days:number): string {
      if(0 >= days) 
        return 'red';
      if(days>=1 && days <=10)
        return '#DA8C10';
  }
    // markerDragEnd($event: AGMMouseEvent) {
    //   console.log($event);
    //   this.latitude = $event.coords.lat;
    //   this.longitude = $event.coords.lng;
    //   this.form.get("lat").setValue(this.latitude); //Working
    //   this.form.get("lang").setValue(this.longitude); //Working
    // }

    onItemSelect(item: any) {
      this.selectedAssetID.push(item.id);
      if(this.nSubModule==1){
        this.filterTable1();
      }else if(this.nSubModule==4){
        this.filterHoardingModify();
      }else{
        this.filterTable2();
      }
    }
    onSelectAll() {
      this.selectedAssetID = this.AssetsDataLists.map(x => x.id);
      // this.selectedAssetID = this.HoardingExpiredLists.map(x => x.asset_type_id);
      this.selectedAssetID = this.selectedAssetID.filter(function(elem, index, self) {
        return index === self.indexOf(elem);
      })
      if(this.nSubModule==1){
        this.filterTable1();
      }else if(this.nSubModule==4){
        this.filterHoardingModify();
      }else{
        this.filterTable2();
      }
    }
    onDeSelectAll() {
      this.selectedAssetID = [];
      if(this.nSubModule==1){
        this.filterTable1();
      }else if(this.nSubModule==4){
        this.filterHoardingModify();
      }else{
        this.filterTable2();
      }
    }
    onItemDeSelect(item: any) {
        this.selectedAssetID.forEach((value,index)=>{
        if(value==item.id) this.selectedAssetID.splice(index,1);
      });
      if(this.nSubModule==1){
        this.filterTable1();
      }else if(this.nSubModule==4){
        this.filterHoardingModify();
      }else{
        this.filterTable2();
      }
    }
  
    doSearch(input){
      this.dataService.setSearchText(input);  
    }
  
    onCreativeItemSelect(item: any) {
      console.log(item)
      this.selectedCreativeIds.push(item.id);
      if(this.nSubModule==1){
        this.filterTable1();
      }else if(this.nSubModule==4){
        this.filterHoardingModify();
      }else{
        this.filterTable2();
      }
    }
    onCreativeSelectAll() {
      // this.selectedCreativeIds = this.HoardingExpiredLists.map(x => x.creative_id);
      this.selectedCreativeIds = this.CreativeDataLists.map(x => x.id);
      this.selectedCreativeIds = this.selectedCreativeIds.filter(function(elem, index, self) {
        return index === self.indexOf(elem);
      })
      if(this.nSubModule==1){
        this.filterTable1();
      }else if(this.nSubModule==4){
        this.filterHoardingModify();
      }else{
        this.filterTable2();
      }
    }
    onCreativeDeSelectAll() {
      this.selectedCreativeIds = [];
      if(this.nSubModule==1){
        this.filterTable1();
      }else if(this.nSubModule==4){
        this.filterHoardingModify();
      }else{
        this.filterTable2();
      }
    }
    onCreativeItemDeSelect(item: any) {
      this.selectedCreativeIds.forEach((value,index)=>{
        if(value==item.id) this.selectedCreativeIds.splice(index,1);
      });
  
      if(this.nSubModule==1){
        this.filterTable1();
      }else if(this.nSubModule==4){
        this.filterHoardingModify();
      }else{
        this.filterTable2();
      }
    }
  
  
    onVendorItemSelect(item: any) {
      console.log(item)
      this.selectedVendorIds.push(item.id);
      if(this.nSubModule==1){
        this.filterTable1();
      }else if(this.nSubModule==4){
        this.filterHoardingModify();
      }else{
        this.filterTable2();
      }
    }
    onVendorSelectAll() {
      // this.selectedVendorIds = this.HoardingExpiredLists.map(x => x.vendor_id);
      this.selectedVendorIds = this.VendorDataLists.map(x => x.id);
      this.selectedVendorIds = this.selectedVendorIds.filter(function(elem, index, self) {
        return index === self.indexOf(elem);
      })
      // this.FilteredHoardingExpiredLists = [...this.HoardingExpiredLists];
      if(this.nSubModule==1){
        this.filterTable1();
      }else if(this.nSubModule==4){
        this.filterHoardingModify();
      }else{
        this.filterTable2();
      }
    }
    onVendorDeSelectAll() {
      this.selectedVendorIds = [];
      // this.FilteredHoardingExpiredLists = [...this.HoardingExpiredLists];
      if(this.nSubModule==1){
        this.filterTable1();
      }else if(this.nSubModule==4){
        this.filterHoardingModify();
      }else{
        this.filterTable2();
      }
    }
    onVendorItemDeSelect(item: any) {
      // this.selectedCreativeIds.splice(this.selectedCreativeIds.indexOf(item.id), 1);
      this.selectedVendorIds.forEach((value,index)=>{
        if(value==item.id) this.selectedVendorIds.splice(index,1);
      });
  
      if(this.nSubModule==1){
        this.filterTable1();
      }else if(this.nSubModule==4){
        this.filterHoardingModify();
      }else{
        this.filterTable2();
      }
    }
    filterHoardingModify(){
      this.dataService.setAssetDataLists(this.selectedAssetID);  
      this.dataService.setCreativeDataLists(this.selectedCreativeIds);  
      this.dataService.setVendorDataLists(this.selectedVendorIds);  
      this.dataService.setSearchText("");  
    }
    filterTable1() {
      // console.log("instore ids - - "+this.selectedAssetID);
      // console.log("creative ids - - "+this.selectedCreativeIds);
      // console.log("vendor ids - - "+this.selectedVendorIds);
      // console.log("---data---"+ JSON.stringify(this.FilteredHoardingExpiredLists));
      if(this.selectedAssetID.length>0  &&  this.selectedCreativeIds.length==0 &&  this.selectedVendorIds.length==0){
          this.FilteredHoardingExpiredLists = [
             ...this.HoardingExpiredLists.filter(x => this.selectedAssetID.includes(x.asset_type_id))
        ];
      }else if(this.selectedAssetID.length==0 &&  this.selectedCreativeIds.length>0 &&  this.selectedVendorIds.length==0){
          this.FilteredHoardingExpiredLists = [
              ...this.HoardingExpiredLists.filter(x => this.selectedCreativeIds.includes(x.creative_id))
        ];
      }else if(this.selectedAssetID.length==0 &&  this.selectedCreativeIds.length==0 &&  this.selectedVendorIds.length>0){
          this.FilteredHoardingExpiredLists = [
              ...this.HoardingExpiredLists.filter(x => this.selectedVendorIds.includes(x.vendor_id))
        ];
      }
  
  
     else if(this.selectedAssetID.length>0  &&  this.selectedCreativeIds.length>0 &&  this.selectedVendorIds.length==0){
      this.FilteredHoardingExpiredLists = [
        ...this.HoardingExpiredLists.filter(x => this.selectedAssetID.includes(x.asset_type_id) && this.selectedCreativeIds.includes(x.creative_id))
      ];
      }else if(this.selectedAssetID.length>0 &&  this.selectedCreativeIds.length==0 &&  this.selectedVendorIds.length>0){
        this.FilteredHoardingExpiredLists = [
          ...this.HoardingExpiredLists.filter(x => this.selectedAssetID.includes(x.asset_type_id) && this.selectedVendorIds.includes(x.vendor_id))
        ];
      }else if(this.selectedAssetID.length==0 &&  this.selectedCreativeIds.length>0 &&  this.selectedVendorIds.length>0){
        this.FilteredHoardingExpiredLists = [
          ...this.HoardingExpiredLists.filter(x => this.selectedCreativeIds.includes(x.creative_id) && this.selectedVendorIds.includes(x.vendor_id))
        ];
      }
  
  
  
      else if(this.selectedAssetID.length==0 &&  this.selectedCreativeIds.length==0 &&  this.selectedVendorIds.length==0){
          this.FilteredHoardingExpiredLists = [...this.HoardingExpiredLists];
      }else{
          this.FilteredHoardingExpiredLists = [
            ...this.HoardingExpiredLists.filter(x => this.selectedAssetID.includes(x.asset_type_id) && this.selectedCreativeIds.includes(x.creative_id)&& this.selectedVendorIds.includes(x.vendor_id))
          ];
      }
  
  
    }
    filterTable2() {
      // console.log("instore ids - - "+this.selectedAssetID);
      // console.log("creative ids - - "+this.selectedCreativeIds);
      // console.log("vendor ids - - "+this.selectedVendorIds);

      if(this.selectedAssetID.length>0  &&  this.selectedCreativeIds.length==0 &&  this.selectedVendorIds.length==0){
          this.filtered_detail_HoardingsLists = [
             ...this.filtered_HoardingsLists.filter(x => this.selectedAssetID.includes(x.asset_type_id))
        ];
      }else if(this.selectedAssetID.length==0 &&  this.selectedCreativeIds.length>0 &&  this.selectedVendorIds.length==0){
          this.filtered_detail_HoardingsLists = [
              ...this.filtered_HoardingsLists.filter(x => this.selectedCreativeIds.includes(x.creative_id))
        ];
      }else if(this.selectedAssetID.length==0 &&  this.selectedCreativeIds.length==0 &&  this.selectedVendorIds.length>0){
          this.filtered_detail_HoardingsLists = [
              ...this.filtered_HoardingsLists.filter(x => this.selectedVendorIds.includes(x.vendor_id))
        ];
      }
  
  
     else if(this.selectedAssetID.length>0  &&  this.selectedCreativeIds.length>0 &&  this.selectedVendorIds.length==0){
      this.filtered_detail_HoardingsLists = [
        ...this.filtered_HoardingsLists.filter(x => this.selectedAssetID.includes(x.asset_type_id) && this.selectedCreativeIds.includes(x.creative_id))
      ];
      }else if(this.selectedAssetID.length>0 &&  this.selectedCreativeIds.length==0 &&  this.selectedVendorIds.length>0){
        this.filtered_detail_HoardingsLists = [
          ...this.filtered_HoardingsLists.filter(x => this.selectedAssetID.includes(x.asset_type_id) && this.selectedVendorIds.includes(x.vendor_id))
        ];
      }else if(this.selectedAssetID.length==0 &&  this.selectedCreativeIds.length>0 &&  this.selectedVendorIds.length>0){
        this.filtered_detail_HoardingsLists = [
          ...this.filtered_HoardingsLists.filter(x => this.selectedCreativeIds.includes(x.creative_id) && this.selectedVendorIds.includes(x.vendor_id))
        ];
      }
  
  
  
      else if(this.selectedAssetID.length==0 &&  this.selectedCreativeIds.length==0 &&  this.selectedVendorIds.length==0){
          this.filtered_detail_HoardingsLists = [...this.filtered_HoardingsLists];
      }else{
          this.filtered_detail_HoardingsLists = [
            ...this.filtered_HoardingsLists.filter(x => this.selectedAssetID.includes(x.asset_type_id) && this.selectedCreativeIds.includes(x.creative_id)&& this.selectedVendorIds.includes(x.vendor_id))
          ];
      }

      if(this.isFromDashboard){
        this.showDetailedView(this.d_selected_hoardingID,this.d_selected_hoardingName);
      }
    }



  onRegionClick(regionID:number,regionName:string){
    this.isShowTab = !this.isShowTab;
    this.selected_region_id = regionID;
    this.selected_region_name = regionName;
    this.f_Region_Showroom_list = this.ShowroomDataLists.filter(s => s.region_id === regionID);
  }
  cancelEditHoarding(){
    this.isEdit =false;
  }
  onBackClick(){
    if(this.nSubModule == 2) {
       this.nSubModule = 1;
       this.clearFilters();
    }else if(this.nSubModule == 1) {
      this.isShowTab = !this.isShowTab;
    }else if(this.nSubModule == 3) {
      this.nSubModule = 2;
    }else if(this.nSubModule == 4) {
      this.clearFilters()
      this.nSubModule = 3;
    }
  }
  editHoarding(){
    this.isEdit =true;
    if(this.isEdit){
      this.form.controls.name.setValue(this.hoardingCurrentData.name);
      this.form.controls.area.setValue(this.hoardingCurrentData.area);
      this.form.controls.address.setValue(this.hoardingCurrentData.address);
      this.form.controls.particulars.setValue(this.hoardingCurrentData.particulars);
      this.form.controls.asset_type_id.setValue(this.hoardingCurrentData.asset_type_id);
      this.form.controls.creative_id.setValue(this.hoardingCurrentData.creative_id);
      this.form.controls.vendor_id.setValue(this.hoardingCurrentData.vendor_id);
      // this.form.controls.lat.setValue(this.hoardingCurrentData.lat);
      this.form.controls.size_w.setValue(this.hoardingCurrentData.size_w);
      // this.form.controls.lang.setValue(this.hoardingCurrentData.lang);
      this.form.controls.size_h.setValue(this.hoardingCurrentData.size_h);
      this.form.controls.install_date.setValue(this.hoardingCurrentData.install_date);
      this.form.controls.expiry_date.setValue(this.hoardingCurrentData.expiry_date);
      this.form.controls.cost.setValue(this.hoardingCurrentData.cost);
      this.form.controls.square_feet.setValue(this.hoardingCurrentData.size_w * this.hoardingCurrentData.size_h);
      this.imageSrc = "https://brandmonitoringapp.grtjewels.com/api/uploads/"+this.hoardingCurrentData.image;

    }
  }

  sortArray(activityLists: { expiryDays: number; }[]) {
    activityLists.sort(this.compare);
  }
  compare( a, b ) {
    return a.expiryDays - b.expiryDays
  }



  discontinue(){
    this.confirmDialogService.confirmThis('Are you sure you want to discontinue ' +this.hoardingCurrentData.name +' ?', () =>  {
      this.isLoading = true;

        console.log(JSON.stringify(this.filtered_detail_HoardingsLists))
        for (var i = 0; i < this.filtered_detail_HoardingsLists.length; i++) {
                if(this.filtered_detail_HoardingsLists[i].id== this.hoardingCurrentData.id){
                  this.filtered_detail_HoardingsLists.splice(i, 1);
                }

       } 
      this.instoreService.hoardingDiscontinue(this.hoardingCurrentData.id,1)
      .pipe(first())
        .subscribe(
        (response) => {
          this.isLoading = false;
          this.toastr.success("Record has been updated successfully", "Success");     
          this.nSubModule = 2;
        },
      (error) => {     
        this.isLoading = false;                 
        this.toastr.warning("Sorry, something went wrong Please try again", "Warning");              
      }
      );
      }, () => {
        
      }); 
  
  }

  requestEmail(type){
    var text= type==0?"damaged":"replacement";
    this.confirmDialogService.confirmThis('Are you sure you want to send a '+ text +' request for ' +this.hoardingCurrentData.name +' ?', () =>  {
      this.isLoading = true;
      this.instoreService.hoardingsrequestEmail(this.user_role_id,this.hoardingCurrentData.id,type)
      .pipe(first())
        .subscribe(
          (response) => {
            this.isLoading = false;
            this.toastr.success("Damaged report sent successfully", "Success"); 
            this.nSubModule = 2;    
          },
          (error) => {     
            this.isLoading = false;                 
            this.toastr.error("Sorry, something went wrong Please try again", "Warning");              
          }
        );
      }, 
      
      () => {
        
      }); 
  
  }
  onHoardingSingleModify(){
    this.form.controls.hoarding_id.setValue(this.hoardingCurrentData.id);
    if(this.f.install_date.value !=""){
      this.form.get("install_date").setValue(moment(this.f.install_date.value).format(this.format)); //Working
    }
    if(this.f.expiry_date.value !=""){
      this.form.get("expiry_date").setValue(moment(this.f.expiry_date.value).format(this.format)); //Working
    }

    const formDataNew = new FormData();   
    formDataNew.append('hoarding_id', this.form.value.hoarding_id);
    formDataNew.append('particulars',  this.form.value.particulars);
    formDataNew.append('region_id',  this.form.value.region_id);
    formDataNew.append('showroom_id', ""+this.selected_showroom_id);
    formDataNew.append('asset_type_id',  this.form.value.asset_type_id);
    formDataNew.append('creative_id',  this.form.value.creative_id);
    formDataNew.append('vendor_id', this.form.value.vendor_id);
    // formDataNew.append('lat',  this.form.value.lat);
    // formDataNew.append('lang',  this.form.value.lang);
    formDataNew.append('cost',  this.form.value.cost);
    formDataNew.append('name',  this.form.value.name);
    formDataNew.append('area',  this.form.value.area);
    formDataNew.append('address',  this.form.value.address);
    formDataNew.append('size_w',  this.form.value.size_w);
    formDataNew.append('size_h', this.form.value.size_h);
    formDataNew.append('square_feet',  this.form.value.square_feet);
    formDataNew.append('install_date',  this.form.value.install_date);
    formDataNew.append('expiry_date', this.form.value.expiry_date);
    formDataNew.append('image', this.form.get('image').value);

    // for (let obj of formDataNew) {
    //   console.log(obj);
    // }
    this.confirmDialogService.confirmThis('Are you sure you want to modify ?', () =>  {
      this.isLoading = true;
      this.instoreService.hoardingSingleModify(formDataNew)
        .pipe(first())
          .subscribe(
          (response) => {
            this.isLoading = false;
            this.toastr.warning("Record has been modified successfully", "Success"); 
            this.getHoardingInformation();
            this.isEdit = false;
            this.selectedHoarding_ID = this.f.hoarding_id.value;
            this.nameHoarding = this.f.name.value;
          },
        (error) => {     
          this.toastr.warning("Sorry, something went wrong Please try again", "Warning");              
          this.isLoading = false;                               
        }
        ); 
      }, () => {
        
      });  
  }
  onHoardingSingleUpdate(){
    this.form.controls.hoarding_id.setValue(this.hoardingCurrentData.id);
    if(this.f.install_date.value !=""){
      this.form.get("install_date").setValue(moment(this.f.install_date.value).format(this.format)); //Working
    }
    if(this.f.expiry_date.value !=""){
      this.form.get("expiry_date").setValue(moment(this.f.expiry_date.value).format(this.format)); //Working
    }
    console.log(JSON.stringify(this.hoardingCurrentData.id)+"==="+JSON.stringify(this.form.value))

    const formDataNew = new FormData();   
    formDataNew.append('hoarding_id', this.form.value.hoarding_id);
    formDataNew.append('particulars',  this.form.value.particulars);
    formDataNew.append('region_id',  this.form.value.region_id);
    formDataNew.append('showroom_id', ""+this.selected_showroom_id);
    formDataNew.append('asset_type_id',  this.form.value.asset_type_id);
    formDataNew.append('creative_id',  this.form.value.creative_id);
    formDataNew.append('vendor_id', this.form.value.vendor_id);
    // formDataNew.append('lat',  this.form.value.lat);
    // formDataNew.append('lang',  this.form.value.lang);
    formDataNew.append('cost',  this.form.value.cost);
    formDataNew.append('name',  this.form.value.name);
    formDataNew.append('address',  this.form.value.address);
    formDataNew.append('area',  this.form.value.area);
    formDataNew.append('size_w',  this.form.value.size_w);
    formDataNew.append('size_h', this.form.value.size_h);
    formDataNew.append('square_feet',  this.form.value.square_feet);
    formDataNew.append('install_date',  this.form.value.install_date);
    formDataNew.append('expiry_date', this.form.value.expiry_date);
    formDataNew.append('image', this.form.get('image').value);

    this.confirmDialogService.confirmThis('Are you sure you want to update ?', () =>  {
      this.isLoading = true;
        this.instoreService.hoardingSingleUpdate(formDataNew)
        .pipe(first())
          .subscribe(
          (response) => {
            this.isLoading = false;
            this.toastr.warning("Record has been updated successfully", "Success");     
            this.getHoardingInformation();
            this.isEdit = false;
            this.selectedHoarding_ID = this.f.hoarding_id.value;
            this.nameHoarding = this.f.name.value;
          },
        (error) => {     
          this.isLoading = false;                 
          this.toastr.warning("Sorry, something went wrong Please try again", "Warning");              
        }
        );
      }, () => {
        
      });  
  }
  get f() { return this.form.controls; }

  showHoardingDetails(data:any){
    this.isFromDashboard = true;
    this.d_selected_hoardingID = data.id;
    this.d_selected_hoardingName = data.name;
    this.showHoardingData(data.region_id,data.regionName,data.showroom_id,data.showroomName);
   }

  showHoardingData(regionID,regionName,showroomID,showroomName) {
  
    this.selected_region_id = regionID;
    this.selected_region_name = regionName;
    this.selected_showroom_id=showroomID;
    this.selected_showroom_name =showroomName;

    // this.clearFilters();

    this.instoreService.getShowroomHoardingLists(this.selected_showroom_id)
    .pipe(first())
      .subscribe(
      (response) => {
        this.all_HoardingsLists = response.result;
        if(this.all_HoardingsLists.length>0){
          for (let i = 0; i < this.all_HoardingsLists.length; i++) {
                this.all_HoardingsLists[i].isChecked = false;
                this.all_HoardingsLists[i].isSelected = false;
          } 
          this.filtered_HoardingsLists = this.all_HoardingsLists;  
          this.nSubModule  = 2;
          this.filterTable2();
        }else{
          this.toastr.warning("No Data Found");
        }
      },(error) => {     
        this.isLoading = false;                               
      }
      );
  

  }

  clearFilters() {
    this.filterform.get("asset_type_id").setValue([]);
    this.filterform.get("creative_id").setValue([]);
    this.filterform.get("vendor_id").setValue([]);
    this.filterform.get("search").setValue('');
    
    this.selectedAssetID = [];
    this.selectedCreativeIds =[];
    this.selectedVendorIds =[];

    if(this.nSubModule==1){
      this.filterTable1();
    }else if(this.nSubModule==4){
      this.filterHoardingModify();
    }else{
      this.filterTable2();
    }
}

  getFloorName(id){
    for (let i = 0; i < this.FloorDataLists.length; i++) {
      if(this.FloorDataLists[i].id===id){
        return this.FloorDataLists[i].name;
      }
    }
  }
  checkAll(){
    this.isAllChecked();
    this.selectedHoarding_Lists=[];
    for (let i = 0; i < this.filtered_detail_HoardingsLists.length; i++) {
      if(this.isAllHoardingsChecked){
          this.filtered_detail_HoardingsLists[i].isChecked = false;
      }else{
        this.filtered_detail_HoardingsLists[i].isChecked = true;
        this.selectedHoarding_Lists.push(this.filtered_detail_HoardingsLists[i]);
      }
    }
    this.isAllChecked();
    // console.log("----checklist-----"+JSON.stringify(this.selectedHoarding_Lists));
  }
  setChecked(id:number){
    this.selectedHoarding_Lists = [];
    for (let i = 0; i < this.filtered_detail_HoardingsLists.length; i++) {
      if(this.filtered_detail_HoardingsLists[i].id===id){
        if(this.filtered_detail_HoardingsLists[i].isChecked){
          this.filtered_detail_HoardingsLists[i].isChecked = false;
          this.selectedHoarding_Lists = [];
        }else{
          this.filtered_detail_HoardingsLists[i].isChecked = true;
          this.selectedHoarding_Lists.push(this.filtered_detail_HoardingsLists[i]);
        }
      }
    }
    this.getCheckedItemList();
  }
  
  isAllChecked() {
      this.isAllHoardingsChecked = this.filtered_HoardingsLists.every(function(item:any) {
        return item.isChecked == true;
      })   
  }
  bulkUpdateModify(isUpdateorModify){
    this.instoreService.setIsUpdateorModify(isUpdateorModify);
    this.nSubModule = 4;
    localStorage.setItem('lists', JSON.stringify(this.selectedHoarding_Lists));

    this.instoreService.setShowRoomID(this.selected_showroom_id);

    this.dataService.setAssetDataLists(this.selectedAssetID);  
    this.dataService.setCreativeDataLists(this.selectedCreativeIds);  
    this.dataService.setVendorDataLists(this.selectedVendorIds);  
    this.dataService.setSearchText(""); 
  }
  getCheckedItemList(){
    this.selectedHoarding_Lists = [];
    for (var i = 0; i < this.filtered_detail_HoardingsLists.length; i++) {
      if(this.filtered_detail_HoardingsLists[i].isChecked)
         this.selectedHoarding_Lists.push(this.filtered_detail_HoardingsLists[i]);
    }
    this.isAllChecked();
  }
  viewModule(){
    let currentUrl = this.router.url;
    this.router.navigateByUrl('/', {skipLocationChange: true}).then(() => {
        this.router.navigate([currentUrl]);
    });
  }
  onSubmit() {
  }
  showDetailedView(id:number,name:string){
    this.nSubModule = 3;
    this.getCheckedItemList();
    this.selectedHoarding_ID =id;
    this.nameHoarding = name;
    this.getHoardingInformation();
  }
  clickHoarding(id:number,name:string){
    this.selectedHoarding_ID =id;
    this.nameHoarding = name;
    this.getHoardingInformation();
    this.isEdit = false;
  }
  getHoardingInformation(){
    this.hoardingCurrentData ;
    this.hoardingPreviousData;
    this.instoreService.getHoardingInformation(this.selectedHoarding_ID)
    .pipe(first())
      .subscribe(
      (response) => {
        this.isLoading = false;
        if(response.result.log.length>0){
          this.isLog = true;
        }else{
          this.isLog = false;
        }
        this.hoardingCurrentData = response.result.hoarding[0];
        this.hoardingPreviousData = response.result.log[0];
        // console.log("==="+JSON.stringify(this.hoardingCurrentData))
      },
    (error) => {     
      this.isLoading = false;                               
    }
    );
  }
  setSelected(id:number){
    this.selectedHoarding_ID =id;
  }
  gotoModule(e, path) {
    this.nSubModule = 3;
  }
  goBack() {
    if(this.nSubModule == 2) {
        this.nSubModule = 1;
    } else if(this.nSubModule == 3) {
      this.nSubModule = 2;
    }
  }
  reloadAssetsLists(){
    this.accountService.getAssetsLists()
    .pipe(first())
      .subscribe(
      (response) => {
        this.isLoading = false;
        this.AssetsDataLists = response.result;
      },
    (error) => {     
      this.isLoading = false;                               
    }
    );
  }
  reloadCreativeLists(){
    this.accountService.getCreativeLists()
    .pipe(first())
      .subscribe(
      (response) => {
        this.isLoading = false;
        this.CreativeDataLists = response.result;
      },
    (error) => {     
      this.isLoading = false;                               
    }
    );
  }
  reloadRegionLists(){
    this.accountService.getRegionsLists()
    .pipe(first())
      .subscribe(
      (response) => {
        this.isLoading = false;
        this.RegionDataLists = response.result;
      },
    (error) => {     
      this.isLoading = false;                               
    }
    );
  }
  reloadVendorLists(){
    this.accountService.getVendorLists()
    .pipe(first())
      .subscribe(
      (response) => {
        this.isLoading = false;
        this.VendorDataLists = response.result;
      },
    (error) => {     
      this.isLoading = false;                               
    }
    );
  }
  reloadFloorLists(){
    this.accountService.getFloorLists()
    .pipe(first())
      .subscribe(
      (response) => {
        this.isLoading = false;
        this.FloorDataLists = response.result;
        // this.FloorDataLists.map(i=>i.isChecked=false)
        // this.sortedFloorData = this.FloorDataLists;
      },
    (error) => {     
      this.isLoading = false;                               
    }
    );
  }
  reloadShowroomLists(){
    this.accountService.getShowroomLists()
    .pipe(first())
      .subscribe(
      (response) => {
        this.isLoading = false;
        this.ShowroomDataLists = response.result;
      },
    (error) => {     
      this.isLoading = false;                               
    }
    );
  }
  // loadHoardingsData() {
  //   this.instoreService.getHoardingLists()
  //   .pipe(first())
  //     .subscribe(
  //     (response) => {
  //       this.all_HoardingsLists = response.result;
  //       for (let i = 0; i < this.all_HoardingsLists.length; i++) {
  //             this.all_HoardingsLists[i].isChecked = false;
  //             this.all_HoardingsLists[i].isSelected = false;
  //             this.all_HoardingsLists[i].isUpdateModify = false;
  //       }  
  //       this.filtered_all_HoardingsLists = this.all_HoardingsLists;     
  //    },(error) => {     
  //     this.isLoading = false;                               
  //   }
  //   );
  // } 
  closeResult:string;
  open(content) {
    this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title',size: 'lg'}).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return  `with: ${reason}`;
    }
  }
  
  startDateClicked(event) {
    this.minDate = event.value;
    this.StartEndDatesOutput.emit(this.getDates());
    this.resetExpiry();
  }
  resetExpiry() {
    this.form.patchValue({
      expiry_date: ''
    });
  }
  
  endDateClicked() {
    if (this.form.controls['install_date'].value) {
      let eventStartTime = new Date(this.form.controls['install_date'].value);
      let eventEndTime = new Date(this.form.controls['expiry_date'].value);
      this.StartEndDatesOutput.emit(this.getDates());
    } else {
      console.log('Please select the start date');
      this.form.controls['expiry_date'].setValue('');
    }
  }
  getDates() {
    let startEndDates = {
      'install_date': this.form.controls['install_date'].value,
      'expiry_date': this.form.controls['expiry_date'].value
    };
    return startEndDates;
  }

  onFileChange(event) {
    
    const max_size = 5242880;
    const allowed_types = ['image/png', 'image/jpeg', 'image/jpg'];


    const reader = new FileReader();
    const file:File = event.target.files[0];

    if (file.size > max_size) {
        alert("Image Size should not exceed more than 5 MB")
        return false;
    }
    
    
    if(event.target.files && event.target.files.length) {
      const [file] = event.target.files;
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.imageSrc = reader.result as string;
        /*
        this.form.patchValue({
          image: reader.result
        });
        */
       this.form.get('image').setValue(event.target.files[0]);
       console.log("onFileChange "+event.target.files[0]);
      };  
   
    }
  }
}
